module.exports = __webpack_public_path__ + "static/media/logo2.f6ac0f7c.svg";